import { go, map, each, split, object, zipL, mapL, every } from "fxjs/es";
import paper from "paper";
import {
  addEventHitTest,
  addEventPathMove,
  makePaperProject,
} from "./utils.js";
import { PaperOffset } from "paperjs-offset";

const getViewBoxFromStr = (vb_str) =>
  go(
    vb_str,
    split(" "),
    mapL((x) => Number(x)),
    zipL(["x", "y", "w", "h"]),
    object
  );

const pathsStrToPaperize = (paths_str_arr, vb_str, min_distance, is_test) => {
  // let t0, t1;
  min_distance = Math.abs(min_distance);
  const off = min_distance / 2;
  // t0 = performance.now();
  //vb_str would be like 'viewbox' attribute inside svg element: "x y w h"
  const viewbox = getViewBoxFromStr(vb_str);
  let paper_scope = new paper.PaperScope();
  paper_scope.activate();
  makePaperProject(
    paper_scope,
    is_test ? viewbox.w : null,
    is_test ? viewbox.h : null,
    is_test ? document.body : null
  );
  const paths_arr = go(
    paths_str_arr,
    map((path_str) => {
      let path;
      const p = new paper_scope.Path(path_str);
      p.name = "as-is";
      if (min_distance > 0) {
        p.data.offset_path = path = PaperOffset.offset(p, off, {
          join: "round",
        });
        path.data.as_is_path = p;
      } else {
        path = p;
      }
      path.name = "offset";
      path.data.collision_check = [path.id];
      path.data.is_collide = false;
      return path;
    })
  );

  const viewbox_path = new paper_scope.Path({
    segments: [
      [viewbox.x + off, viewbox.y + off],
      [viewbox.x + viewbox.w - off, viewbox.y + off],
      [viewbox.x + viewbox.w - off, viewbox.y + viewbox.h - off],
      [viewbox.x + off, viewbox.y + viewbox.h - off],
    ],
    closed: true,
    name: "viewbox",
  });
  viewbox_path.data.collision_check = [viewbox_path.id];
  viewbox_path.data.is_collide = false;
  paths_arr.unshift(viewbox_path);
  // t1 = performance.now();
  // console.log("paperize, offsetting", Math.round(t1 - t0), "ms");
  return { scope: paper_scope, paths_arr: paths_arr };
};

export const checkPathsCollision = (
  input_paths_arr,
  vb_str,
  min_distance,
  is_test = false
) => {
  let t0, t1;
  let check_time = 0;
  let test_paths_arr, paper_scope;
  let result;
  const is_input_paths_string = !(
    input_paths_arr[0] instanceof paper.Path ||
    input_paths_arr[0] instanceof paper.CompoundPath
  );

  if (is_input_paths_string) {
    const { scope, paths_arr } = pathsStrToPaperize(
      input_paths_arr,
      vb_str,
      min_distance,
      is_test
    );
    test_paths_arr = paths_arr;
    paper_scope = scope;
  } else {
    test_paths_arr = input_paths_arr;
    paper_scope = test_paths_arr[0]._project._scope;
    go(
      test_paths_arr,
      each((path) => {
        path.data.collision_check = [path.id];
        path.data.is_collide = false;
      })
    );
  }

  t0 = performance.now();
  const is_paths_collision = go(
    test_paths_arr,
    each((test_path) => {
      if (!test_path.data.is_collide) {
        go(
          test_paths_arr,
          each((compare_path) => {
            if (compare_path.data.collision_check.indexOf(test_path.id) < 0) {
              check_time++;
              compare_path.data.collision_check.push(test_path.id);
              test_path.data.collision_check.push(compare_path.id);
              const is_intersect = test_path.intersects(compare_path);
              if (is_intersect) {
                test_path.data.is_collide = compare_path.data.is_collide = true;
              }
            }
          })
        );
      }
    }),
    map((test_path) => test_path.data.is_collide)
  );
  t1 = performance.now();
  console.log(
    "collision check",
    Math.round(t1 - t0),
    "ms for",
    check_time,
    "try"
  );
  if (is_test) {
    go(
      paper_scope.project.activeLayer.children,
      each((path) => {
        path.set({
          visible: true,
          strokeColor: "black",
          strokeWidth: 2,
        });
        if (path.data.is_collide) {
          path.set({
            visible: true,
            strokeColor: "red",
            strokeWidth: 2,
          });
        }
      })
    );
    addEventPathMove(paper_scope, test_paths_arr);
    const is_artboard_collision = is_paths_collision.shift();
    result = {
      paper_scope,
      test_paths_arr,
      is_artboard_collision,
      is_paths_collision,
    };
  } else {
    paper_scope.remove();
    paper_scope = null;
    const is_artboard_collision = is_paths_collision.shift();
    result = {
      is_artboard_collision,
      is_paths_collision,
    };
  }
  return result;
};

export const isTwoPathsCollide = (
  pathdata_str_a_tobe_offset,
  pathdata_str_b,
  min_distance
) => {
  let paper_scope = new paper.PaperScope();
  paper_scope.activate();
  makePaperProject(paper_scope);
  const path_a = new paper_scope.Path(pathdata_str_a_tobe_offset, {
    insert: false,
    closed: true,
  });
  const path_b = new paper_scope.Path(pathdata_str_b, {
    insert: false,
    closed: true,
  });
  const offset_options = {
    join: "round",
    insert: false,
  };
  const offset_path_b = PaperOffset.offset(
    path_b,
    min_distance,
    offset_options
  );
  paper_scope.remove();
  paper_scope = null;
  return path_a.intersects(offset_path_b);
};

export const isPathCollide = (pathdata_arr) => {
  let paper_scope = new paper.PaperScope();
  paper_scope.activate();
  makePaperProject(paper_scope);
  const paper_paths_arr = go(
    pathdata_arr,
    map((pathdata) => {
      const path = new paper_scope.Path(pathdata);
      path.data.collision_check = [path.id];
      path.data.collide_with = [];
      return path;
    })
  );
  go(
    paper_paths_arr,
    each((test_path) => {
      go(
        paper_paths_arr,
        each((compare_path) => {
          if (compare_path.data.collision_check.indexOf(test_path.id) === -1) {
            compare_path.data.collision_check.push(test_path.id);
            test_path.data.collision_check.push(compare_path.id);
            if (compare_path.intersects(test_path)) {
              test_path.data.collide_with.push(compare_path);
              compare_path.data.collide_with.push(test_path);
            }
          }
        })
      );
    })
  );
  paper_scope.remove();
  paper_scope = null;
  return go(
    paper_paths_arr,
    map((path) => {
      return map((path) => path.pathData, path.data.collide_with);
    })
  );
};

export const isPathContain = (outer_path, inner_path) => {
  return go(
    inner_path.segments,
    every((segment) => outer_path.contains(segment.point))
  );
};

export const getPaperPathsCollisionResults = (
  paper_paths_arr,
  is_visible_update_collision_color = false,
  is_check_time = false
) => {
  let t0, t1;
  if (is_check_time) {
    t0 = performance.now();
  }
  let no_of_check = 0;
  const is_paths_collision = go(
    paper_paths_arr,
    //initialize
    each((paper_path) => {
      paper_path.data.is_collide = false;
      paper_path.data.collision_checked = [paper_path.id];
    }),
    //collision_test
    each((test_path) => {
      go(
        paper_paths_arr,
        each((compare_path) => {
          if (test_path !== compare_path) {
            if (!test_path.data.is_collide) {
              if (
                compare_path.data.collision_checked.indexOf(test_path.id) < 0
              ) {
                no_of_check++;
                compare_path.data.collision_checked.push(test_path.id);
                test_path.data.collision_checked.push(compare_path.id);
                const is_paths_not_container =
                  test_path.name !== "container_path" &&
                  compare_path.name !== "container_path";

                const is_intersect_or_inside =
                  test_path.intersects(compare_path) ||
                  (is_paths_not_container &&
                    (isPathContain(compare_path, test_path) ||
                      isPathContain(test_path, compare_path)));
                if (is_intersect_or_inside) {
                  test_path.data.is_collide = compare_path.data.is_collide = true;
                }
              }
              if (!test_path.data.is_collide) {
                const is_outside_container =
                  compare_path.name === "container_path" &&
                  !isPathContain(compare_path, test_path);
                if (is_outside_container) {
                  test_path.data.is_collide = compare_path.data.is_collide = true;
                }
              }
            }
          }
        })
      );
    }),
    map((test_path) => {
      if (is_visible_update_collision_color) {
        if (test_path.data.is_collide) {
          test_path.set({
            strokeColor: "red",
            strokeWidth: 3,
          });
        } else {
          test_path.set({
            strokeColor: "black",
            strokeWidth: 1,
          });
        }
      }
      return test_path.data.is_collide;
    })
  );
  if (is_check_time) {
    t1 = performance.now();
    console.log("collision_check_time", Math.round(t1 - t0), "ms");
  }
  return { is_paths_collision, no_of_check };
};

export const stickerCollisionCheck = (
  container_pathdata_str,
  test_pathdata_str_arr,
  is_check_time = false,
  is_united = true,
  is_visible = false
) => {
  let t0, t1;
  if (is_check_time) {
    t0 = performance.now();
  }
  let paper_scope = new paper.PaperScope();
  paper_scope.activate();

  makePaperProject(
    paper_scope,
    is_visible && 1000,
    is_visible && 1000,
    is_visible && document.body
  );

  const paths_arr = go(
    test_pathdata_str_arr,
    map((pathdata_str) => {
      const is_compound_pathdata = [...pathdata_str.matchAll(/z/g)].length > 1;
      let path = is_compound_pathdata
        ? new paper_scope.CompoundPath(pathdata_str)
        : new paper_scope.Path(pathdata_str);
      if (is_united) {
        if (path instanceof paper_scope.CompoundPath) {
          let united_path = null;
          go(
            path.children,
            each((sub_path) => {
              united_path = !united_path
                ? sub_path
                : united_path.unite(sub_path, { insert: false });
            })
          );
          paper_scope.project.activeLayer.addChild(united_path);
          //기존 compoundPath는 project에서 제거
          path.remove();
          //path reference를 united path로 변경
          path = united_path;
        }
      }
      path.name = "design_path";
      path.data.collision_checked = [path.id];
      path.data.is_collide = false;
      path.applyMatrix = true;
      path.is_closed = true;
      if (!path.clockwise) {
        path.reverse();
      }
      is_visible &&
        path.set({
          fillColor: "transparent",
          strokeColor: "black",
          strokeWidth: 1,
        });
      return path;
    })
  );

  const container_path = new paper_scope.Path(container_pathdata_str);
  is_visible &&
    container_path.set({
      fill: "transparent",
      strokeColor: "green",
      strokeWidth: 1,
    });
  container_path.name = "container_path";
  container_path.data.collision_checked = [container_path.id];
  container_path.data.is_collide = false;

  paths_arr.unshift(container_path);

  const { no_of_check, is_paths_collision } = getPaperPathsCollisionResults(
    paths_arr,
    is_visible
  );

  if (!is_visible) {
    paper_scope.remove();
    paper_scope = null;
  } else {
    window.paper = paper_scope;
    addEventHitTest(paper_scope);
  }
  const container_path_tobe_resolved = is_paths_collision.shift();
  const design_paths_tobe_resolved_arr = is_paths_collision;
  if (is_check_time) {
    t1 = performance.now();
    console.log("Collision Calculation", Math.round(t1 - t0), "ms");
  }
  return {
    no_of_check,
    container_path_tobe_resolved,
    design_paths_tobe_resolved_arr,
  };
};
